'use strict';
import React from 'react';
import flux from 'utils/flux';
import AltContainer from 'alt-container';
import dom from 'utils/dom';
import LoadingSpinner from 'components/spinner/spinner';

var PrivacyPage = React.createClass({
    displayName: 'PrivacyPage',
    mixins: [],
    propTypes: {},
    componentWillMount() {
        flux.getStore('app').loadPrivacy();
    },
    render() {
        const appStore = flux.getStore('app');
        const modalStore = flux.getStore('modals');
        return (
            <div className="page terms">
                <div className="container--centered">
                    <AltContainer stores={{ appStore, modalStore }}
                        render={(props) => {
                            if (modalStore.getState().loading) {
                                return (<LoadingSpinner/>);
                            }
                            if (!props.appStore.privacy) { return false; }
                            return <div dangerouslySetInnerHTML={dom.setInnerHtml(props.appStore.privacy)} />;
                        }}>
                    </AltContainer>
                </div>
            </div>
        );
    }
});

module.exports = PrivacyPage;



// WEBPACK FOOTER //
// ./app/pages/privacyPolicy/index.jsx